import React from 'react';
import {  NavLink } from 'react-router-dom';
import styled  from 'styled-components';
const Header = () => {
    return ( 
        <ContenedorHeader>
                  <Titulo>ELECTRONICA HERTZ</Titulo> 
                  <Menu>
                    <NavLink to='/'>Inicio</NavLink>
                    <NavLink to='/producto'>Productos</NavLink>
                    <NavLink to='/contacto'>Contacto</NavLink>
                    <NavLink to='/acerca-de'>Acerca de</NavLink>
                  </Menu>
        </ContenedorHeader>
     );
}
 
const ContenedorHeader =styled.header`
    text-align:center;
    margin-bottom:40px;
   

    @media(max-width: 60rem){ /* 950px */
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
 
        & > div {
            display: flex;
            margin-bottom: 1.25rem; /* 20px */
            justify-content: end;
        }
    }

`;
const Titulo = styled.h1`
    margin-bottom:10px;
    font-size:28px;
    text-transform: uppercase;

    @media(max-width: 60rem){ /* 950px */
    font-size: 2rem; /* 32px */
}  
`;

const Menu = styled.nav`
    width: 100%;
    text-align: center;
    background: #092c4c;
    grid-column: span 2;
    border-radius: 3px;
 
    a {
        color: #fff;
        display: inline-block;
        padding: 15px 20px;
    }
 
    a:hover {
        background: #43abaf;
        text-decoration: none;
    }

    @media(max-width: 60rem){ /* 950px */
    font-size: 2rem; /* 32px */
}
`;


export default Header;